




















































































































































































import {Component, Vue} from 'vue-property-decorator';
import moment from 'moment';
import {
  優先卸個別変更依頼型,
  入札商品検索条件型,
  入札確定依頼型,
  入札開始依頼型,
  入札額変更依頼型,
  卸比較優先卸変更依頼型,
  卸比較商品型,
  未確定入札削除依頼型,
  未確定入札取得依頼型,
  確定済入札削除依頼型,
  表示内容入札表出力依頼型,
} from '@/type/estimates/comparison';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import ComparisonExcelDialog from '@/views/estimates/ComparisonExcelDialog.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import UsageClassSelector from '@/components/item/UsageClassSelector.vue';
import {卸型} from '@/type/wholesale/wholesale';
import 入札商品検索条件チェッカー from '@/type/estimates/入札商品検索条件チェッカー';
import 入札開始依頼チェッカー from '@/type/estimates/入札開始依頼チェッカー';
import 入札確定チェッカー from '@/type/estimates/入札確定チェッカー';
import {入札出力依頼型, 入札型} from '@/type/estimates/bid';
import {progress} from '@/script/progress';

@Component({
  components: {
    ComparisonExcelDialog,
    Datepicker,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
    UsageClassSelector,
  },
  filters: {
    // 0の場合非表示とするため
    priceFormat(value: number): string {
      if (!value) {
        return '';
      }
      return value.toLocaleString('ja-JP', {style: 'currency', currency: 'JPY'});
    },
  },
})
export default class Comparison extends Vue {
  // data
  最新入札: 入札型 | null = null;
  卸比較商品一覧: 卸比較商品型[] = [];
  卸一覧: 卸型[] = [];
  適用開始日: Date | null = null;
  薬価差率算出基準: string = '現薬価';
  選択卸コード: string = '';
  選択商品コード: string = '';
  卸変更行数: number | null = null;
  検索条件: 入札商品検索条件型 = {...this.デフォルト検索条件};

  modal: boolean = false;
  アラートメッセージ: string[] | string | null = null;

  // computed
  get デフォルト検索条件(): 入札商品検索条件型 {
    return {
      適用開始日: null,
      ソート区分: '商品名カナ',
      使用区分: null,
      商品区分: null,
      並び順使用区分: '無効',
    };
  }

  get 入札中である(): boolean {
    if (this.最新入札 == null) {
      return false;
    }
    return this.最新入札.入札確定フラグ === '未確定';
  }

  get 入札前である(): boolean {
    if (this.最新入札 == null) {
      return true;
    }
    if (this.最新入札.入札確定フラグ == null) {
      return true;
    }
    return this.最新入札.入札確定フラグ === '確定';
  }

  get 取消できる(): boolean {
    return this.卸比較商品一覧.length !== 0;
  }

  get 新薬価を含む(): boolean {
    return this.卸比較商品一覧.some((商品) => 商品.新薬価);
  }

  // methods
  検索条件入力エラー判定(name: string): boolean {
    this.検索条件.適用開始日 = this.適用開始日;
    const checker = new 入札商品検索条件チェッカー(this.検索条件);
    return checker.hasError(name);
  }

  async 入札商品検索(): Promise<void> {
    this.検索条件.適用開始日 = this.適用開始日;
    const checker = new 入札商品検索条件チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    const 検索処理 = async (): Promise<void> => {
      await api.入札商品を検索する(this.検索条件)
        .then((response: any) => {
          this.卸比較商品一覧 = response.商品一覧;
          if (this.卸比較商品一覧.length === 0) {
            this.showAlert('該当の入札は存在しません');
            return;
          }
          if (response.アラートメッセージ) {
            this.showAlert(response.アラートメッセージ);
          }
        }).catch((error: any) => {
          if (!error.data.errors) {
            this.showAlert(error.data.message);
          }
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
        });
    };
    await progress(検索処理);
  }

  async 未確定入札取得(): Promise<void> {
    const 未確定入札取得依頼: 未確定入札取得依頼型 = {
      適用開始日: this.適用開始日,
    };
    await api.未確定入札商品一覧を取得する(未確定入札取得依頼)
      .then((response: any) => {
        this.卸比較商品一覧 = response;
      }).catch((error: any) => {
        if (!error.data.errors) {
          this.showAlert(error.data.message);
        }
        if (error.data.errors) {
          this.showAlert(error.data.errors);
        }
      });
  }

  async 入札開始(): Promise<void> {
    const 入札開始依頼: 入札開始依頼型 = {
      適用開始日: this.適用開始日,
    };
    const checker = new 入札開始依頼チェッカー(入札開始依頼);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    const 入札開始処理 = async (): Promise<void> => {
      await api.入札を開始する(入札開始依頼)
        .then(() => {
          this.最新の入札取得();
          this.未確定入札取得();
          // viewEditingStateModule.画面の編集を開始する(); // 破棄されますが～メッセージを出さない
        }).catch((error: any) => {
          if (!error.data.errors) {
            this.showAlert(error.data.message);
          }
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
        });
    };
    await progress(入札開始処理);
  }

  async 入札確定(): Promise<void> {
    const 入札確定依頼: 入札確定依頼型 = {
      卸比較商品一覧: this.卸比較商品一覧,
    };
    const checker = new 入札確定チェッカー(this.卸比較商品一覧, this.卸一覧);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    const 入札確定処理 = async (): Promise<void> => {
      await api.入札を確定する(入札確定依頼)
        .then(() => {
          this.卸比較商品一覧 = [];
          this.卸変更行数 = null;
          this.最新の入札取得();
        }).catch((error: any) => {
          if (!error.data.errors) {
            this.showAlert(error.data.message);
          }
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
        });
    };
    await progress(入札確定処理);
  }

  async 最新の入札取得(): Promise<void> {
    this.最新入札 = await api.最新の入札を取得する();
    if (this.最新入札 != null && this.最新入札.入札確定フラグ === '未確定') {
      this.適用開始日 = this.最新入札.適用開始日;
    }
  }

  async exportForWholesale(卸コード: string, 作成区分: string): Promise<void> {
    if (!this.最新入札?.入札開始日 || !this.最新入札?.作成番号 || !this.最新入札?.適用開始日 || 卸コード === '') {
      return;
    }
    const 入札出力依頼: 入札出力依頼型 = {
      入札開始日: this.最新入札.入札開始日,
      作成番号: this.最新入札.作成番号,
      適用開始日: this.最新入札.適用開始日,
      卸コード,
      作成区分,
    };
    const ファイル名 = this.ファイル名作成(卸コード);
    const 出力処理 = async (): Promise<void> => {
      await download.入札出力(ファイル名, 入札出力依頼);
    };
    await progress(出力処理);
    this.modal = false;
  }

  async 表示内容出力(): Promise<void> {
    const ファイル名 = '卸比較一覧.xlsx';
    const 表示内容入札表出力依頼: 表示内容入札表出力依頼型 = {
      卸比較商品一覧: this.卸比較商品一覧,
      適用開始日: this.適用開始日,
      薬価差率算出基準: this.薬価差率算出基準,
    };
    const 出力処理 = async (): Promise<void> => {
      await download.表示内容入札表出力(ファイル名, 表示内容入札表出力依頼);
    };
    await progress(出力処理);
  }

  ファイル名作成(卸コード: string): string {
    const now = new Date();
    moment.locale('ja');
    const 対象卸 = this.卸一覧.find((卸) => 卸.卸コード === 卸コード);
    if (!対象卸) {
      this.showAlert('指定された卸は取込対象ではありません');
      return '';
    }
    return '入札_' + 対象卸.卸名 + '_' + moment(this.適用開始日).format('YYYYMMDD') + moment(now).format('hhmmss') + '.xlsx';
  }

  async reload(): Promise<void> {
    await this.未確定入札取得();
  }

  async 最低値(): Promise<void> {
    const 優先卸変更依頼: 卸比較優先卸変更依頼型 = {
      卸比較商品一覧: this.卸比較商品一覧,
    };
    const 最低値更新処理 = async (): Promise<void> => {
      await api.卸比較優先卸を最低値に変更する(優先卸変更依頼)
        .then((response: any) => {
          this.卸比較商品一覧 = response.商品一覧;
          this.卸変更行数 = response.卸変更行数;
        }).catch((error: any) => {
          if (!error.data.errors) {
            this.showAlert(error.data.message);
          }
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
        });
    };
    await progress(最低値更新処理);
  }

  async 現納入卸(): Promise<void> {
    const 優先卸変更依頼: 卸比較優先卸変更依頼型 = {
      卸比較商品一覧: this.卸比較商品一覧,
    };
    const 優先卸更新処理 = async (): Promise<void> => {
      await api.卸比較優先卸を現納入卸に変更する(優先卸変更依頼)
        .then((response: any) => {
          this.卸比較商品一覧 = response.商品一覧;
          this.卸変更行数 = null;
        }).catch((error: any) => {
          if (!error.data.errors) {
            this.showAlert(error.data.message);
          }
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
        });
    };
    await progress(優先卸更新処理);
  }

  async 個別変更(): Promise<void> {
    if (this.選択商品コード === '' || this.選択卸コード === '') {
      return;
    }
    const 優先卸変更処理 = async (): Promise<void> => {
      await this.優先卸個別変更(this.選択商品コード, this.選択卸コード);
    };
    await progress(優先卸変更処理);
  }

  async 優先卸個別変更(商品コード: string, 卸コード: string): Promise<void> {
    const 優先卸個別変更依頼: 優先卸個別変更依頼型 = {
      商品コード,
      卸コード,
    };
    this.卸比較商品一覧 = await api.優先卸個別変更する(優先卸個別変更依頼);
    this.卸変更行数 = null;
  }

  async クリア(): Promise<void> {
    if (this.入札中である) {
      const 未確定入札削除依頼: 未確定入札削除依頼型 = {
        適用開始日: this.適用開始日,
      };
      const 削除処理 = async (): Promise<void> => {
        await api.未確定入札を削除する(未確定入札削除依頼)
          .then((response: any) => {
            this.最新の入札取得();
            this.卸変更行数 = null;
            this.卸比較商品一覧 = [];
            viewEditingStateModule.画面の編集を終了する();
          }).catch((error: any) => {
            if (!error.data.errors) {
              this.showAlert(error.data.message);
            }
            if (error.data.errors) {
              this.showAlert(error.data.errors);
            }
          });
      };
      await progress(削除処理);
    }
    if (this.入札前である) {
      const 確定済入札削除依頼: 確定済入札削除依頼型 = {
        商品一覧: this.卸比較商品一覧,
      };
      const 削除処理 = async (): Promise<void> => {
        await api.確定入札を削除する(確定済入札削除依頼)
          .then((response: any) => {
            this.最新の入札取得();
            this.卸変更行数 = null;
            this.卸比較商品一覧 = [];
            viewEditingStateModule.画面の編集を終了する();
          }).catch((error: any) => {
            if (!error.data.errors) {
              this.showAlert(error.data.message);
            }
            if (error.data.errors) {
              this.showAlert(error.data.errors);
            }
          });
      };
      await progress(削除処理);
    }
    this.検索条件 = {...this.デフォルト検索条件};
    this.closeDialog('取消ダイアログ');
  }

  async 卸一覧を取得する(): Promise<void> {
    const wholesales = await api.卸一覧を取得する();
    this.卸一覧 = wholesales.filter((卸) => 卸.備蓄品発注有効区分 !== '有効');
  }

  async 入札額を変更する(商品コード: string, 卸コード: string, 納入価: number, 適用終了日: Date | null, 更新バージョン: number): Promise<void> {
    if (!商品コード || !卸コード || !適用終了日 || !更新バージョン) {
      return;
    }
    const 入札額変更依頼: 入札額変更依頼型 = {商品コード, 卸コード, 納入価, 更新バージョン, 適用開始日: this.適用開始日, 適用終了日};
    const 更新処理 = async (): Promise<void> => {
      await api.入札額を更新する(入札額変更依頼)
        .then((response: any) => {
          const 卸比較商品: 卸比較商品型 = response;
          const index = this.卸比較商品一覧.findIndex((商品) => 商品.商品コード === 商品コード);
          this.卸比較商品一覧.splice(index, 1, 卸比較商品);
        });
    };
    await progress(更新処理);
  }

  async 入札情報を同期する(): Promise<void> {
    await api.入札情報を同期する()
      .catch((error: any) => {
        if (!error.data.errors) {
          this.showAlert(error.data.message);
        }
        if (error.data.errors) {
          this.showAlert(error.data.errors);
        }
      });
  }

  採用卸クラス(商品: 卸比較商品型, 卸コード: string): object {
    if (this.選択商品コード === 商品.商品コード && this.選択卸コード === 卸コード) {
      return {'background-color-bid': true};
    }
    if (商品.採用卸コード === 卸コード) {
      return {'background-color-blue': true};
    }
    if (商品.最低値卸コード一覧.includes(卸コード)) {
      return {'background-color-pink': true};
    }
    return {'background-color-blue': 商品.採用卸コード === 卸コード};
  }

  選択行クラス(商品コード: string): object {
    if (this.選択商品コード === '') return {};
    return {'background-color-navy-blue': this.選択商品コード === 商品コード};
  }

  行を選択(商品コード: string): void {
    this.選択商品コード = 商品コード;
  }

  入札を選択(商品コード: string, 卸コード: string): void {
    this.選択商品コード = 商品コード;
    this.選択卸コード = 卸コード;
  }

  エクセル処理ダイアログを開く(): void {
    this.modal = true;
  }

  closeExcelDialog(): void {
    this.modal = false;
  }

  async 初期化(): Promise<void> {
    await this.卸一覧を取得する();
  }

  openDialog(name: string): void {
    this.$modal.show(name);
  }

  closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('アラート');
  }

  // lifecycle hooks
  async created(): Promise<void> {
    await this.初期化();
    await this.最新の入札取得();
    if (this.入札中である) {
      const 取得処理 = async (): Promise<void> => {
        await this.入札情報を同期する();
        await this.未確定入札取得();
      };
      progress(取得処理);
      // viewEditingStateModule.画面の編集を開始する(); // 破棄されますが～メッセージを出さない
      return;
    }
    viewEditingStateModule.初期化する();
  }
}
